import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@services';
import { Observable } from 'rxjs';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const KeplerPurecloudInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    const urlToMatch = environment.api.kepler.purecloud.url;
    const authService = inject(AuthService);

    if (urlToMatch && req.url.startsWith(urlToMatch)) {
        const clone = cloneAndAddHeaders(req, {
            Authorization: `Bearer ${authService.accessToken}`,
            'csdt-authorization-app': csdtAuthApp,
            'Content-Type': 'application/json',
            'X-Api-Key': environment.api.kepler.purecloud.apiKey,
        });
        console.debug('[Interceptors][KeplerPurecloudInterceptor] Modified request:', clone);
        return next(clone);
    } else {
        return next(req);
    }
};
